import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-fc42727e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "press-center"
};
const _hoisted_2 = {
  class: "text"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关于我们，最新动态在这里", -1));

const _hoisted_6 = {
  class: "tab-box"
};
const _hoisted_7 = {
  class: "news-box"
};
const _hoisted_8 = {
  class: "new-item-box"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_svg_icon = _resolveComponent("svg-icon");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(_toDisplayString(_ctx.title), 1), _hoisted_4, _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
    class: _normalizeClass(_ctx.num == 0 ? 'active' : ''),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.changeNum(0))
  }, "企业动态", 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.num == 1 ? 'active' : ''),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.changeNum(1))
  }, "行业新闻", 2), _createElementVNode("div", {
    class: "more",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.goNews())
  }, "更多 >")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.IndustryInformationList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.code,
      class: "new-item",
      onClick: $event => _ctx.toPath(`/newsDetail?id=${item.code}`)
    }, [_createVNode(_component_el_image, {
      src: _ctx.imgUrl(item.coverFileUrl),
      alt: "",
      lazy: "",
      fit: "cover"
    }, null, 8, ["src"]), _createElementVNode("div", _hoisted_10, [item.top == 1 ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      icon: "zhiding_icon",
      width: "18px",
      height: "18px",
      style: {
        "margin-right": "5px"
      }
    })) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_11, _toDisplayString(item.createTime), 1)], 8, _hoisted_9);
  }), 128))])])])]);
}